import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { Observable, Subject, config } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ConfigManagerService {
  public configJson;
  public platform_override = 'app_platform_override';
  public app_override = 'app_override';
  public planObject = {};
  constructor(private http: HttpClient) { }

  setPlanObject(planObject) {
    this.planObject = planObject;
  }

  returnTheConfig(appObj) {
    // const appObj = this.appSelectorService.getSelectedApp();
    if (appObj && this.planObject[appObj.id]) {
      return this.planObject[appObj.id];
    } else if (appObj && this.planObject[appObj.os]) {
      return this.planObject[appObj.os];
    } else {
      return this.planObject['default'];
    }
  }

  isPropertyPresentInList(listName, property, appObj, cb) {
    const configJson: any = this.returnTheConfig(appObj);
    const flag = configJson[listName] && configJson[listName].hasOwnProperty(property);
    cb && cb(flag);
  }
}
